export default __webpack_public_path__ + "static/media/Campus-hr-h-g.1a9b13dc.svg";